
(function(){
  'use strict';
  var q=function(s,c){return (c||document).querySelector(s)},qa=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};
  // Drawer
  function drawer(){
    var t=q('.sw-menu-toggle'),d=q('.sw-drawer'),o=q('.sw-drawer-overlay'),c=q('.sw-drawer-close');
    if(!t||!d||t.dataset.bound) return; t.dataset.bound='1';
    function open(){d.hidden=false;o.hidden=false;requestAnimationFrame(function(){d.classList.add('sw-open');o.classList.add('sw-open')});t.setAttribute('aria-expanded','true');document.body.style.overflow='hidden';(c||d).focus();}
    function close(){d.classList.remove('sw-open');o.classList.remove('sw-open');t.setAttribute('aria-expanded','false');document.body.style.overflow='';setTimeout(function(){d.hidden=true;o.hidden=true},260);t.focus();}
    t.addEventListener('click',function(){d.hidden?open():close()});
    if(c) c.addEventListener('click',close);
    o.addEventListener('click',close);
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!d.hidden) close()});
  }
  // Reveal
  function reveal(){
    var els=qa('.sw-rv:not(.sw-in)');
    if(!('IntersectionObserver' in window)||matchMedia('(prefers-reduced-motion: reduce)').matches||window.Shopify&&window.Shopify.designMode){els.forEach(function(e){e.classList.add('sw-in')});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('sw-in');io.unobserve(x.target)}})},{rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){io.observe(e)});
  }
  // Toast
  var toastEl;
  function toast(html){
    if(!toastEl){toastEl=document.createElement('div');toastEl.className='sw-toast';document.body.appendChild(toastEl);}
    toastEl.innerHTML=html;requestAnimationFrame(function(){toastEl.classList.add('sw-on')});
    clearTimeout(toastEl._t);toastEl._t=setTimeout(function(){toastEl.classList.remove('sw-on')},4200);
  }
  function money(cents){
    var fmt=(window.SW&&window.SW.moneyFormat)||'${{amount}}';
    var v=(cents/100).toFixed(2); var parts=v.split('.'); parts[0]=parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/,parts.join('.'));
  }
  function updateCount(n){qa('.sw-cart-count').forEach(function(b){b.textContent=n;b.hidden=!n;});}
  function addToCart(id,qty,btn){
    if(btn){btn.disabled=true;btn.dataset.label=btn.textContent;btn.textContent='Adding…';}
    return fetch((window.SW&&window.SW.routes.cart_add_url||'/cart/add')+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:id,quantity:qty})})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j}})})
      .then(function(res){
        if(!res.ok){toast(res.j.description||res.j.message||'Could not add to cart');return;}
        document.dispatchEvent(new CustomEvent('cart:add',{detail:{id:id,qty:qty}}));
        return fetch((window.SW&&window.SW.routes.cart_url||'/cart')+'.js').then(function(r){return r.json()}).then(function(c){
          updateCount(c.item_count);
          toast('Added '+qty+' × '+(res.j.product_title||'item')+' <a href="'+(window.SW&&window.SW.routes.cart_url||'/cart')+'">View cart ('+c.item_count+')</a>');
        });
      }).catch(function(){toast('Could not add to cart')})
      .then(function(){if(btn){btn.disabled=false;btn.textContent=btn.dataset.label;}});
  }
  function cards(){
    document.addEventListener('click',function(e){
      var b=e.target.closest('[data-sw-add]'); if(!b) return; e.preventDefault();
      addToCart(parseInt(b.getAttribute('data-sw-add'),10),parseInt(b.getAttribute('data-sw-qty')||'1',10),b);
    });
  }
  // Product form
  function product(){
    qa('.sw-product-form').forEach(function(f){
      if(f.dataset.bound) return; f.dataset.bound='1';
      var variants=JSON.parse(q('[data-sw-variants]',f.closest('.sw-pdp')).textContent);
      var sel=q('select[name="id"]',f),qty=q('input[name="quantity"]',f),btn=q('button[name="add"]',f),moq=parseInt(qty.getAttribute('min')||'1',10);
      var pdp=f.closest('.sw-pdp'),quoteAt=parseInt(pdp.getAttribute('data-sw-quote-at')||'0',10);
      var rfq=q('.sw-app-blocks',pdp),pay=q('.sw-pay',f);
      function variant(){var id=sel?parseInt(sel.value,10):variants[0].id;for(var i=0;i<variants.length;i++){if(variants[i].id===id)return variants[i]}return variants[0];}
      function update(){
        var v=variant(),n=Math.max(moq,parseInt(qty.value,10)||moq); qty.value=n;
        var total=v.price*n;
        qa('[data-sw-price]',pdp).forEach(function(el){el.textContent=money(v.price)});
        qa('[data-sw-tier-price]',pdp).forEach(function(el){var pct=parseFloat(el.getAttribute('data-sw-tier-price'))||0;el.textContent=money(Math.round(v.price*(1-pct/100)))});
        var msrp=parseFloat(pdp.getAttribute('data-sw-msrp')||'0');
        if(msrp>0){var m=Math.round((msrp*100-v.price)/(msrp*100)*100);qa('[data-sw-margin]',pdp).forEach(function(el){el.textContent=(m>0?m:0)+'%'});}
        if(btn){btn.disabled=!v.available;btn.textContent=v.available?('Add '+n+' to cart · '+money(total)):'Sold out';}
        if(v.featured_image&&v.featured_image.src){var mi=q('.sw-main-img img',pdp);if(mi){mi.src=v.featured_image.src;}}
        var quote=quoteAt&&n>=quoteAt;
        if(btn) btn.style.display=quote?'none':'';
        if(pay) pay.style.display=quote?'none':'';
        if(rfq) rfq.classList.toggle('sw-quote-only',quote);
        qa('.sw-tiers tbody tr',pdp).forEach(function(tr){var lo=parseInt(tr.getAttribute('data-lo')||'0',10),hi=parseInt(tr.getAttribute('data-hi')||'999999',10);tr.classList.toggle('sw-active',n>=lo&&n<=hi)});
      }
      if(sel) sel.addEventListener('change',update);
      qty.addEventListener('change',update); qty.addEventListener('input',update);
      var st=qa('.sw-qty button',f); if(st.length===2){st[0].addEventListener('click',function(e){e.preventDefault();qty.value=Math.max(moq,(parseInt(qty.value,10)||moq)-1);update()});st[1].addEventListener('click',function(e){e.preventDefault();qty.value=(parseInt(qty.value,10)||moq)+1;update()});}
      f.addEventListener('submit',function(e){
        if(pdp.hasAttribute('data-sw-ajax')){e.preventDefault();addToCart(variant().id,parseInt(qty.value,10)||moq,btn).then(update);}
      });
      update();
    });
    qa('.sw-thumbs img').forEach(function(t){t.addEventListener('click',function(){var mi=q('.sw-main-img img',t.closest('.sw-gallery'));mi.src=t.getAttribute('data-full')||t.src;qa('.sw-thumbs img',t.closest('.sw-gallery')).forEach(function(x){x.classList.remove('sw-active')});t.classList.add('sw-active')})});
  }
  // Collection sort
  function collection(){
    var s=q('.sw-sort-select'); if(s&&!s.dataset.bound){s.dataset.bound='1';s.addEventListener('change',function(){var u=new URL(location.href);u.searchParams.set('sort_by',s.value);u.searchParams.delete('page');location.href=u.toString();});}
  }
  function init(){drawer();reveal();product();collection();}
  cards();
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:select',function(){qa('.sw-rv').forEach(function(e){e.classList.add('sw-in')})});
})();
